import AdminLayout from "../../../components/admin/layout/AdminLayout";
import ManagerList from "../../../components/admin/manager/ManagerList";

function ManagerListPage() {
  return (
    <AdminLayout>
      <ManagerList />
    </AdminLayout>
  );
}

export default ManagerListPage;
